import { useEffect, useMemo } from 'react';
import { useAuth } from 'react-oidc-context';
import { isHybridRoute } from 'routes/routeHelper';

export const useHybridAuthGate = (): boolean => {
  const { isLoading } = useAuth();

  const shouldWaitForAccessToken = useMemo(() => {
    return (
      isHybridRoute(window.location.pathname) &&
      localStorage.getItem('needAuthToken') === 'true'
    );
  }, []);

  useEffect(() => {
    if (!shouldWaitForAccessToken) return;
    if (!isLoading) {
      localStorage.removeItem('needAuthToken');
    }
  }, [isLoading, shouldWaitForAccessToken]);

  return !shouldWaitForAccessToken || !isLoading;
};
